import { render, staticRenderFns } from "./DonorRegistration.vue?vue&type=template&id=258928fe"
import script from "./DonorRegistration.vue?vue&type=script&lang=js"
export * from "./DonorRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports